<template>
  <div class="login">
    <div class="form">
      <div class="title">管理員登入</div>
      <el-form
        :model="loginForm"
        :rules="rules"
        ref="loginForm"
        label-width="100px"
      >
        <el-form-item label="帳號" prop="account">
          <el-input v-model="loginForm.account"></el-input>
        </el-form-item>
        <el-form-item label="密碼" prop="password">
          <el-input
            v-model="loginForm.password"
            @keyup.native.enter="login"
            type="password"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="error-message" v-if="err">
        {{ err }}
      </div>
      <el-button class="login-btn" type="primary" @click="login"
        >登入</el-button
      >
    </div>
  </div>
</template>

<script>
import Api from "@/api/MaganmentApi";
import HandleForm from "@/mixin/HandleForm";

export default {
  mixins: [HandleForm],
  data() {
    return {
      err: "",
      loginForm: {
        account: "",
        password: ""
      },
      rules: {
        account: [{ required: true, message: "請輸入帳號", trigger: "blur" }],
        password: [
          { required: true, message: "請輸入密碼", trigger: "blur" },
          { min: 5, message: "至少輸入5個字", trigger: "blur" }
        ]
      }
    };
  },
  computed: {},
  methods: {
    async login() {
      this.$refs["loginForm"].validate(async valid => {
        if (valid) {
          let data = {
            account: this.loginForm.account.toString().trim(),
            password: this.loginForm.password
          };
          try {
            const res = await Api.login(data);
            const user = res.data;
            this.err = "";
            localStorage.setItem("token", user.auth.token);
            Api.token = user.auth.token;
            this.$router.push({ name: "management" });
          } catch (e) {
            this.err = this.parseErrorMsg(e);
          }
        } else {
          return false;
        }
      });
    }
  },
  created() {},
  mounted() {},
  components: {}
};
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);

  .form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.9);
    width: 350px;
    height: 400px;

    .title {
      font-size: 24px;
      margin-bottom: 30px;
    }

    .login-btn {
      margin-top: 20px;
    }
  }

  .error-message {
    font-size: 12px;
    margin: 5px;
    color: #f56c6c;
    display: flex;
    justify-content: center;
  }
}
</style>
